import AWS from 'aws-sdk'
import XandrAPI from '@/api/XandrAPI'
import { find } from 'lodash'

AWS.config.region = process.env.AWS_REGION || 'us-east-1'
AWS.config.credentials = new AWS.CognitoIdentityCredentials({ IdentityPoolId: process.env.IDENTITY_POOL_ID })
const s3 = new AWS.S3()
const BUCKET = process.env.CONFIG_BUCKET
const CONFIG_FILES = [
  'dataset-amrld-household.json.gz',
  'dataset-amrld-respondent.json.gz',
  'dataset-programs.json.gz',
  'dataset-nielsen.json.gz',
  'dataset-mri.json.gz',
]

/**
 *
 * @param {String} traitType
 * @returns traits from the config S3 bucket
 */
const getSegmentationTraits = function (traitType) {
  let traits = XandrAPI.getSegmentationTraits(traitType).then(traitData => {
    let setDataSetForEachNode = function (node) {
      if (node.children) {
        for (let c of node.children) {
          setDataSetForEachNode(c)
        }
      } else {
        node.dataset = traitType
      }
    }
    setDataSetForEachNode(traitData)
    traitData.id = traitType
    return traitData
  })
  return traits
}

/**
 * shows, household, respondents, and shows will be shared under the same root for AMRLD
 * @param {} datasets
 */
const distributeAMRLDDatasets = function (datasets) {
  const AMRLD_DATASET_IDS = ['shows', 'household', 'respondent']
  const amrldDatasets = datasets.filter(x => AMRLD_DATASET_IDS.includes(x.id))
  const nonAmrldDatasets = datasets.filter(x => !AMRLD_DATASET_IDS.includes(x.id))
  const amrldDataset = {
    children: amrldDatasets,
    id: 'amrld',
    name: 'AMRLD',
  }
  nonAmrldDatasets.push(amrldDataset)
  return nonAmrldDatasets
}

const changeCatalinaToNCS = function (datasets) {
  for (let d of datasets) {
    if (d.name === 'Catalina') {
      d.name = 'NCS'
    }
  }
  return datasets
}

const sortDatasets = function (datasets) {
  datasets.sort((a, b) => {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  })
  return datasets
}

const fetchAllWorkbenchConfigs = function () {
  let adstraTraits = getSegmentationTraits('adstra')
  let prismTraits = getSegmentationTraits('prism')
  let dnbTraits = getSegmentationTraits('dnb')
  let byodTraits = getSegmentationTraits('byod')
  let maxTraits = getSegmentationTraits('max')
  let tveTraits = getSegmentationTraits('tve')
  let epsilonTraits = getSegmentationTraits('epsilon')
  let dPlusTraits = getSegmentationTraits('d+')
  let dcrTraits = getSegmentationTraits('dcr')
  fetchDatasetFamilies()
  const promises = CONFIG_FILES.map(k =>
    s3
      .getObject({ Bucket: BUCKET, Key: k })
      .promise()
      .then(o => JSON.parse(o.Body.toString())),
  )
  return Promise.all([
    adstraTraits,
    prismTraits,
    dnbTraits,
    byodTraits,
    maxTraits,
    tveTraits,
    epsilonTraits,
    dPlusTraits,
    dcrTraits,
    ...promises,
  ])
    .then(distributeAMRLDDatasets)
    .then(changeCatalinaToNCS)
    .then(sortDatasets)
}

const fetchDatasetFamilies = function () {
  return s3
    .getObject({ Bucket: BUCKET, Key: 'dataset_families.json' })
    .promise()
    .then(o => {
      return JSON.parse(o.Body.toString())
    })
}

const getConfigFilesForConfigType = function (cfgKey) {
  return {
    async fetchConfig() {
      const obj = await s3.getObject({ Bucket: BUCKET, Key: cfgKey }).promise()
      return JSON.parse(obj.Body.toString())
    },
    fetchDatasets(datasets, datasetId) {
      const selectedDataset = (datasetId && find(datasets, { id: datasetId })) || []
      // load non optional datasets and append the selected dataset
      const keys = datasets
        .filter(dataset => !dataset.optional)
        .concat(selectedDataset)
        .map(d => extractFileName(d.url))
      const promises = keys.map(k =>
        s3
          .getObject({ Bucket: BUCKET, Key: k })
          .promise()
          .then(o => JSON.parse(o.Body.toString())),
      )
      return Promise.all(promises)
    },
  }
}

function extractFileName(url) {
  const parts = url.split('/')
  return `${parts[parts.length - 1]}.gz` // remove .gz suffix after all other envs have been updated and las/ad/sm-config.json files updated
}
export default {
  fetchAllWorkbenchConfigs,
  fetchDatasetFamilies,
  getConfigFilesForConfigType,
}



// WEBPACK FOOTER //
// ./src/app/api/ConfigAPI.js